<div
  #topElement
  *ngIf="!finalResponse"
  id="cac-prequal-success-div-backGround"
  class="col-md-12 divBorder"
>
  <div id="cac-prequal-success-div-right" class="">
    <div class="divWhiteBackground">
      <div
        *ngIf="saveMeCounter != 60"
        id="save-me-timer"
        name="save-me-timer"
        class="desktop save-me-timer alert alert-warning"
      >
        This page will expire in {{ saveMeCounter }} seconds.
      </div>
      <div
        *ngIf="saveMeCounter != 60"
        id="save-me-timer"
        name="save-me-timer"
        class="mobileOnly save-me-timer-mobile alert alert-warning"
      >
        This page will expire in {{ saveMeCounter }} seconds.
      </div>
      <form
        id="cac-prequal-success-form"
        onSubmit="{this.handleSubmit}"
        class="formStyle"
      >
        <div class="wizard desktop">
          <div role="presentation" class="custom-display-inline">
            <div class="left-slot">
              <a href="/">
                <img
                  src="{{ logoURL }}"
                  alt="Credit Acceptance"
                  width="150px"
                  height="35px"
                />
              </a>
            </div>
          </div>

          <div
            *ngIf="!openLoanError"
            id="cac-prequal-success"
            class="form-group center"
          >
            <h2 class="congrats h3-black" id="cac-success-congrats">
              {{ formFieldData?.congrats }}
              <div>{{ formFieldData?.successPrequalified }}</div>
            </h2>
            <div class="h4-black">
              {{ formFieldData?.monthlyPaymentUpTo }}${{ monthlyPayment }}
            </div>
            <p>{{ formFieldData?.monthlyPaymentvary }}</p>
          </div>
          <div
            *ngIf="openLoanError"
            id="cac-prequal-openLoan"
            class="form-group"
          >
            <h2 class="congrats h3-black bold center" id="cac-sorry-message">
              {{ formFieldData?.openLoanError }}
            </h2>
            <div
              *ngIf="dealers.length"
              class="sub-title h4-black open-loan-error-msg"
            >
              {{ formFieldData?.connectMessage }}
            </div>
          </div>
          <div>
            <div class="imgspacing" *ngIf="!openLoanError">
              <img src="{{ prequalImg }}" alt="" width="100%" />
              <div class="image-over-text" *ngIf="!openLoanError">
                <div class="h4-black m-0">
                  {{ formFieldData?.monthlyPaymentValidity }}
                  {{ formFieldData?.monthlyPaymentValidityDays }}
                </div>
              </div>
            </div>
            <div
              class="form-group center"
              *ngIf="!openLoanError && dealers.length"
            >
              <div class="congrats h4-black bold center">
                {{ formFieldData.prequalifiedText }}
              </div>
            </div>
            <div
              class="form-group center"
              *ngIf="!openLoanError && dealers.length"
            >
              <div class="h4-black">
                {{ formFieldData.localDealerMatch }} {{ residenceData?.city }},
                {{ residenceData?.userState }}.
              </div>
            </div>

            <div
              *ngIf="dealers.length > 0 && openLoanError"
              [ngClass]="{ 'open-loan-error': openLoanError }"
            >
              <div class="sub-title">
                {{ formFieldData?.findVehicleenrolledDealerShip }}
              </div>
              <div class="dealer-info-container">
                <div *ngFor="let dealer of dealers; let i = index">
                  <div id="dealer{{ i }}" class="dealer-info-item">
                    <div class="custom-display-inline dealer-info-align">
                      <p class="form-field-black dealer-name">
                        {{ dealer?.dealerName }}
                      </p>
                      <p class="form-field-black">
                        {{ dealer?.addressLine1 | titlecase }}
                      </p>
                      <p class="form-field-black">
                        {{ dealer?.city | titlecase }}, {{ dealer?.state }}
                        {{ dealer?.zip }}
                      </p>
                      <p class="form-field-black">
                        <a
                          *ngIf="dealer.phone"
                          href="tel:{{ dealer.phone | phoneFormat }}"
                          class="phone-number"
                          >{{ dealer.phone | phoneFormat }}</a
                        >
                      </p>
                    </div>
                    <div
                      *ngIf="i !== 2"
                      class="custom-display-inline dealer-info-vertical"
                    >
                      <hr class="dealer-info-hr-vertical" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p *ngIf="!dealers.length">
              <strong class="h4-black"
                >{{ formFieldData?.noDealersMessage }}
              </strong>
            </p>
          </div>
        </div>
        <div class="mobileOnly wizard">
          <div role="presentation" class="heading center">
            <div class="heading">
              <a href="/">
                <img
                  src="{{ logoURL }}"
                  alt="Credit Acceptance"
                  width="150px"
                  height="35px"
                />
              </a>
            </div>
          </div>
          <div
            *ngIf="!openLoanError"
            id="cac-prequal-success"
            class="form-group center"
          >
            <h2 class="congrats h3-black" id="cac-success-congrats">
              {{ formFieldData?.congrats }}
              <div>{{ formFieldData?.successPrequalified }}</div>
            </h2>
            <div class="h4-black">
              {{ formFieldData?.monthlyPaymentUpTo }}${{ monthlyPayment }}
            </div>
            <p>{{ formFieldData?.monthlyPaymentvary }}</p>
          </div>
          <div
            *ngIf="openLoanError"
            id="cac-prequal-success-mobile"
            class="form-group"
          >
            <h2
              class="congrats h3-black bold center"
              id="cac-sorry-message-mobile"
            >
              {{ formFieldData.openLoanError }}
            </h2>
            <div
              *ngIf="dealers.length"
              class="sub-title h4-black open-loan-error-msg-mobile"
            >
              {{ formFieldData?.connectMessage }}
            </div>
          </div>
          <div class="imgspacing" *ngIf="!openLoanError">
            <img src="{{ prequalImg }}" alt="" width="100%" />
            <div class="text-center">
              <div class="h4-black m-0">
                {{ formFieldData?.monthlyPaymentValidity }}
                {{ formFieldData?.monthlyPaymentValidityDays }}
              </div>
            </div>
          </div>
          <div
            class="form-group center"
            *ngIf="!openLoanError && dealers.length"
          >
            <div class="congrats h4-black bold center">
              {{ formFieldData.prequalifiedText }}
            </div>
          </div>
          <div
            class="form-group center"
            *ngIf="!openLoanError && dealers.length"
          >
            <div class="h4-black">
              {{ formFieldData.localDealerMatch }} {{ residenceData?.city }},
              {{ residenceData?.userState }}.
            </div>
          </div>

          <div
            *ngIf="dealers.length > 0 && openLoanError"
            [ngClass]="{ 'open-loan-error': openLoanError }"
          >
            <div class="sub-title">
              {{ formFieldData?.findVehicleenrolledDealerShip }}
            </div>

            <div
              *ngFor="let dealer of dealers; let i = index"
              class="formStyle"
            >
              <div id="mobiledealer{{ i }}">
                <div class="blackColor-80">
                  <p class="form-field-black dealer-name">
                    {{ dealer?.dealerName }}
                  </p>
                  <p class="form-field-black">
                    {{ dealer?.addressLine1 | titlecase }}
                  </p>
                  <p class="form-field-black">
                    {{ dealer?.city | titlecase }}, {{ dealer?.state }}
                    {{ dealer?.zip }}
                  </p>
                  <p class="form-field-black">
                    <a
                      *ngIf="dealer.phone"
                      href="tel:{{ dealer.phone | phoneFormat }}"
                      class="phone-number"
                      >{{ dealer.phone | phoneFormat }}</a
                    >
                  </p>
                </div>

                <hr class="dealer-info-hr-horizontal" />
              </div>
            </div>
          </div>
          <p *ngIf="!dealers.length">
            <strong class="h4-black"
              >{{ formFieldData?.noDealersMessage }}
            </strong>
          </p>
        </div>

        <div *ngIf="dealers.length">
          <div class="sub-title h4-black" *ngIf="openLoanError">
            {{ formFieldData?.wanttosave }}
          </div>

          <label
            id="cac-ssn-consent"
            class="osm-ssn-consent"
            [innerHTML]="osmSSNConsentContent | safeHtml"
          >
          </label>

          <div class="cac-agreement-consent">
            <input
              type="checkbox"
              aria-labelledby="cac-ssn-consent"
              id="osmSsnConsent"
              tabIndex="1"
              name="osmSsnConsent"
              (change)="onCheckboxChange($event)"
            />
            <div class="osm-agree custom-display-inline">I Agree</div>
          </div>
          <div class="osm-save-me-time">
            {{ formFieldData.saveMeTimeMessage1 }} "{{
              openLoanError
                ? formFieldData.saveMeTime
                : formFieldData.seeDealers
            }}" {{ formFieldData.saveMeTimeMessage2 }}
          </div>

          <div class="row form-group center pt-20">
            <div class="col text-center">
              <button
                id="{openLoanOrNoBureauError?'cac-saveme-time-submit':'cac-see-dealers-submit'}"
                class="btn btn-primary btn-default b-size center-button col-right Acceptance-Bold"
                [class.disabled]="!isUserAgreed"
                [disabled]="!isUserAgreed || isWaiting"
                (click)="handleSubmit()"
              >
                <span *ngIf="isWaiting" class="fa fa-spinner fa-spin"></span>
                <span>
                  &nbsp;
                  {{
                    openLoanError
                      ? formFieldData?.saveMeTime
                      : formFieldData.seeDealers
                  }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<capq-final-success-response
  [adobeScriptLoaded]="adobeScriptLoaded"
  [prequalified]="!openLoanError"
  [dealers]="dealers"
  *ngIf="finalResponse"
></capq-final-success-response>
